<section id="content">
  <form id="form">
    <div class="row">
      <div class="col-md-12 col-xs-12 table-cont">
        <div class="form-group">
          <div class="card">
            <div class="card-title">
              <h2>RFP Management</h2>
            </div>
            <div class="cont">
              <div class="group">
                <div class="collapse-title">
                  RFP Management
                  <i class="collapse-icon fa"></i>
                </div>
                <div class="table-responsive">
                  <!-- Table -->
                  <p-table #dt1 class="table" styleClass="ui-table-customers"
                           tableStyleClass="table" [value]="rfpData" [rows]="10"
                           [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true" scrollHeight="500px"
                           [resizableColumns]="true" [loading]="" [paginator]="true"
                           currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                           [filterDelay]="0" [globalFilterFields]="['customerName', 'deploymentType', 'productGroup', 'rfpReferenceNumber']">
                    <ng-template pTemplate="caption">
                      <div class="flex" style="float: left;">
                        <p-button *ngIf="(authenticationService.applanceRole.accessLevel || 0) >= accessLevelEnum.read_write"
                                  label="Add RFP" [outlined]="true" icon="pi pi-plus-circle"
                                  (onClick)="navigateToAddRfp()"></p-button>
                      </div>
                    
                      <div style="text-align: right">
                        <button type="button" pButton icon="pi pi-file-excel" iconPos="left"
                            label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;"
                            class="ui-button-success"></button>
                        <button type="button" pButton icon="pi pi-file-pdf" iconPos="left"
                            label="PDF" (click)="exportPdf()"
                            class="ui-button-warning"></button>
                    </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="id">#
                          <p-sortIcon field="id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="customerName">Customer Name
                          <p-sortIcon field="customerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="deploymentType">Deployment Type
                          <p-sortIcon field="deploymentType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="productGroup">Product Group
                          <p-sortIcon field="productGroup"></p-sortIcon>
                        </th>
                        <th pSortableColumn="rfpReferenceNumber">RFP Reference Number
                          <p-sortIcon field="rfpReferenceNumber"></p-sortIcon>
                        </th>
                        <th pSortableColumn="inquiryDate">Inquiry Date
                          <p-sortIcon field="inquiryDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="submissionDate">Submission Date
                          <p-sortIcon field="submissionDate"></p-sortIcon>
                        </th>
                        <th>Actions</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>
                          <p-columnFilter field="customerName" type="text" display="menu" placeholder="Customer Name"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="deploymentType" type="text" display="menu" placeholder="Deployment Type"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="productGroup" type="text" display="menu" placeholder="Product Group"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="rfpReferenceNumber" type="text" display="menu" placeholder="RFP Reference Number"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="inquiryDate" type="date" display="menu" placeholder="Inquiry Date"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="submissionDate" type="date" display="menu" placeholder="Submission Date"></p-columnFilter>
                        </th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rfp let-i="rowIndex">
                      <tr>
                        <td>{{ i + 1 }}</td>
                        <td>{{ rfp.customerName }}</td>
                        <td>{{ rfp.deploymentType }}</td>
                        <td>{{ rfp.productGroup }}</td>
                        <td>{{ rfp.rfpReferenceNumber }}</td>
                        <td>{{ rfp.inquiryDate | date: 'MM/dd/yyyy' }}</td>
                        <td>{{ rfp.submissionDate | date: 'MM/dd/yyyy' }}</td>
                        <td>
                          <button pButton type="button" icon="pi pi-eye" class="p-ripple p-element p-button p-component p-button-icon-only p-button-rounded p-button-text" (click)="viewRfp(rfp.id)"></button>
                          <button pButton type="button" icon="pi pi-pencil" class="p-ripple p-element p-button-warning p-component p-button-icon-only p-button-rounded p-button-text" (click)="editRfp(rfp.id)"></button>
                          <button pButton type="button" icon="pi pi-trash" class="p-ripple p-element p-button-danger p-component p-button-icon-only p-button-rounded p-button-text" (click)="deleteRfpById(rfp.id)"></button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="8">No RFPs found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>


</section>